<template>
	<div class="activity-wrapper">
		<img :src="slotPng" class="activity-slot" />
		<img :src="props.icon" class="activity-icon" />
	</div>
</template>

<script setup lang="ts">
import slotPng from '@/assets/images/slot.png';

const props = defineProps<{
	icon: string;
}>();
</script>

<style scoped>
.activity-wrapper {
	position: relative;

	height: 60px;
	width: 60px;
}

.activity-icon {
	position: absolute;

	left: 0px;
	top: 0px;
	bottom: 0px;
	right: 0px;

	height: 100%;

	aspect-ratio: 1;

	scale: 0.8;
}

.activity-slot {
	height: 100%;

	aspect-ratio: 1;
}
</style>
